import { Inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { LinkRequestsGateway } from '../gateways/LinkRequestsGateway';
import { FailureReason } from '../models/LinkRequestStatus';

import { mapErrorToFailureReason } from './mapErrorToFailureReason';

interface RejectLinkRequestFailureResult {
    success: false;
    failureReason: FailureReason;
}

export type RejectLinkRequestResult = { success: true } | RejectLinkRequestFailureResult;

@Injectable()
export class RejectLinkRequestUseCase {
    constructor(@Inject('LinkRequestsGateway') private linkRequestsGateway: LinkRequestsGateway) {}

    exec(token: string): Observable<RejectLinkRequestResult> {
        return this.linkRequestsGateway.rejectLinkRequest(token).pipe(
            map(() => ({ success: true as const })),
            catchError((error) => {
                const failureReason = mapErrorToFailureReason(error);
                return of({ success: false, failureReason });
            }),
        );
    }
}
